import React from 'react';
import { Link } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const FeaturedArticle = ({ article }) => {
  const getDifficultyColor = (level) => {
    const colors = {
      beginner: 'text-success bg-success/10',
      intermediate: 'text-warning bg-warning/10',
      advanced: 'text-error bg-error/10'
    };
    return colors?.[level] || colors?.beginner;
  };

  return (
    <article className="relative bg-card border border-border rounded-lg overflow-hidden hover:shadow-xl hover:border-primary/50 transition-all duration-300">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
        <div className="relative h-64 md:h-80 lg:h-full min-h-[400px] overflow-hidden">
          <Image
            src={article?.image}
            alt={article?.imageAlt}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-4 left-4">
            <span className="px-4 py-2 rounded-full text-xs font-bold bg-primary text-primary-foreground">
              Featured Article
            </span>
          </div>
        </div>

        <div className="p-6 md:p-8 lg:p-10 flex flex-col justify-center">
          <div className="flex items-center gap-3 mb-4">
            <span className={`px-3 py-1 rounded-full text-xs font-bold ${getDifficultyColor(article?.difficulty)}`}>
              {article?.difficulty?.charAt(0)?.toUpperCase() + article?.difficulty?.slice(1)}
            </span>
            <span className="text-xs text-muted-foreground">{article?.category}</span>
            <span className="text-xs text-muted-foreground">•</span>
            <div className="flex items-center gap-1 text-xs text-muted-foreground">
              <Icon name="Clock" size={14} />
              <span>{article?.readTime} min read</span>
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground mb-4 hover:text-primary transition-colors duration-300">
            {article?.title}
          </h2>

          <p className="text-base md:text-lg text-muted-foreground mb-6 line-clamp-4">
            {article?.excerpt}
          </p>

          <div className="flex items-center gap-4 mb-6">
            <Image
              src={article?.authorImage}
              alt={article?.authorImageAlt}
              className="w-12 h-12 rounded-full object-cover"
            />
            <div>
              <p className="text-sm font-medium text-foreground">{article?.author}</p>
              <p className="text-xs text-muted-foreground">{article?.date}</p>
            </div>
          </div>

          <Link
            to={`/technical-blog/${article?.slug}`}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg font-bold bg-primary text-primary-foreground hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300 w-fit"
          >
            <span>Read Full Article</span>
            <Icon name="ArrowRight" size={18} />
          </Link>

          {article?.tags && article?.tags?.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-6">
              {article?.tags?.map((tag, index) => (
                <span
                  key={index}
                  className="px-3 py-1 text-xs rounded bg-muted text-muted-foreground"
                >
                  #{tag}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </article>
  );
};

export default FeaturedArticle;